module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Financial Statement")]), _vm._v(" "), _c('el-col', {
    ref: "summaryCard",
    attrs: {
      "align": "center",
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover",
      "body-style": "height: 35em;"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Invoice Summary")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "bottom",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "align": "left",
      "sm": 12,
      "md": 12,
      "lg": 10
    }
  }, [_c('h4', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("Sharer Billing ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 12,
      "md": 12,
      "lg": 14
    }
  }, [_c('span', {
    style: ('font-size: ' + _vm.textSize + '; color: slateblue;')
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.dueFees, 0)))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "bottom",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "align": "left",
      "sm": 12,
      "md": 12,
      "lg": 10
    }
  }, [_c('h4', [_vm._v("Received to Date: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 12,
      "md": 12,
      "lg": 14
    }
  }, [_c('span', {
    style: ('font-size: ' + _vm.textSize + '; color: seagreen;')
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.paidFees, 0)))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "bottom",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "align": "left",
      "sm": 12,
      "md": 12,
      "lg": 10
    }
  }, [_c('h4', [_vm._v("Outstanding: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 12,
      "md": 12,
      "lg": 14
    }
  }, [_c('span', {
    style: ('font-size: ' + _vm.textSize + '; color: goldenrod;')
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.outstandingFees, 0)))])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasUtilTransactions) ? _c('el-row', [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.utilLabel) + " Invoicing")])]), _vm._v(" "), _c('el-col', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.utilData,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "advance",
      "label": "Advance",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sharing",
      "label": "Sharing",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "utility",
      "label": _vm.utilLabel + ' Due',
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "penalties",
      "label": "Penalties",
      "align": "right"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "align": "left",
      "sm": 12,
      "md": 12,
      "lg": 10
    }
  }, [_c('h4', [_vm._v("Total Invoicing")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 12,
      "md": 12,
      "lg": 14
    }
  }, [_c('span', {
    style: ('font-size: ' + _vm.textSize + '; color: slateblue;')
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.totalInvoicing, 0)))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "align": "left",
      "sm": 12,
      "md": 12,
      "lg": 10
    }
  }, [_c('h4', [_vm._v("Total Paid")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 12,
      "md": 12,
      "lg": 14
    }
  }, [_c('span', {
    style: ('font-size: ' + _vm.textSize + '; color: seagreen;')
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.totalPaid, 0)))])])], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "border-style": "solid",
      "border-width": "1px",
      "border-color": "lightgrey",
      "margin-top": "0.7em",
      "margin-bottom": "0.7em"
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "left",
      "sm": 12,
      "md": 12,
      "lg": 10
    }
  }, [_c('h4', [_vm._v("Balance")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 12,
      "md": 12,
      "lg": 14
    }
  }, [_c('span', {
    style: ('font-size: ' + _vm.textSize + '; color: indianred;')
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.totalInvoicing - _vm.totalPaid, 0)))])])], 1), _vm._v(" "), (this.percent > 0) ? _c('el-row', {
    staticStyle: {
      "padding-top": "2em"
    }
  }, [_c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "percentage": Number(_vm.percent),
      "status": _vm.dueStatus
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    ref: "gridCard",
    attrs: {
      "align": "left",
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', {
    staticClass: "card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Breakdown by Sharer")])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orgData,
      "stripe": "",
      "border": "",
      "height": "490",
      "show-summary": "",
      "sum-text": "Total",
      "summary-method": _vm.totaller
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoiced",
      "label": "Invoiced",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "paid",
      "label": "Paid",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outstanding",
      "label": "O/S",
      "align": "right"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.charts) ? _c('el-col', {
    ref: "pieChartCard",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "align": "center",
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('br'), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.charts,
      "donut": true,
      "thousands": ",",
      "legend": "bottom",
      "download": false
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4fc3a9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/finance/InvoiceSummary.vue
// module id = 1704
// module chunks = 0